import { toast } from '@/components/toasts/toast.helpers'

import { fetchingAPI, apiService } from '../../api'
import { csvStreamingComplete, updateUploadResponse } from './organizationUsersCSV.redux'

export const uploadUserCSV =
  ({ users, newTags, configNames, organizationid }) =>
  async (dispatch) => {
    try {
      const csvStream = await fetchingAPI(
        `${apiService.core}/api/organizations/${organizationid}/users/upload`,
        'POST',
        dispatch,
        JSON.stringify({ users, newTags, configNames })
      )
      const responseReader = csvStream.getReader()
      const readStream = () =>
        responseReader.read().then(({ value, done }) => {
          if (done) {
            return dispatch(csvStreamingComplete())
          }
          const decodedResponseData = new TextDecoder('utf-8').decode(value)

          dispatch(
            updateUploadResponse(
              decodedResponseData
                .split('\n')
                .filter((row) => row !== '')
                .map((row) => row.split(','))
            )
          )
          return readStream()
        })
      // Always resolve streamingComplete on failure so the UI can recover —
      // otherwise isImporting stays stuck and the modal can't close.
      await readStream().catch((err) => {
        console.error('uploadUserCSV stream read failed', err)
        toast.error('Upload connection was interrupted. Please try again.', { cause: err })
        dispatch(csvStreamingComplete())
      })
    } catch (err) {
      console.error('uploadUserCSV failed', err)
      toast.error('Failed to start upload. Please try again.', { cause: err })
      dispatch(csvStreamingComplete())
    }
  }
